import React from 'react'
import { Link } from 'react-router-dom'
import { ListItem } from 'Lib/List'
import { Truncate } from 'Lib/Text'
import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import { ROUTER_BASE_PATH } from 'AccountsConstants/routes'
import {
  isPastTrip,
  formatTripName,
  triggerClevertap,
  convertToSafariCompatibleDate
} from 'AccountsUtils'
import CalendarIcon from './CalendarIcon'
import TripTypeIcon from './TripTypeIcon'

const tripsListItem = ({ tripDetails }) => {
  const isPast = isPastTrip(tripDetails.bookingStatus)
  const headingColor = isPast ? 'c-black-50' : 'c-black-80'
  const clickHandler = () => {
    let dateString = new Date(convertToSafariCompatibleDate(tripDetails.travelDate))
    dateString = dateString.toString()
    const clevertapData = {
      'event type': 'trip details clicked',
      platform: CLEVERTAP_PLATFORM,
      'booking name': tripDetails.tripName,
      trip_ID: tripDetails.tripId,
      'fulfillment time': dateString.substr(16, 5),
      'fulfillment date': dateString.substr(4, 11),
      'product name': tripDetails.tripType
    }
    triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
  }
  return (
    <ListItem arrow={true} enableRipple={true}>
      <Link to={`${ROUTER_BASE_PATH}/trips/${tripDetails.tripId}`} className="flag h-76" onClick={clickHandler}>
        <div className="flag__fix amr-10">
          <CalendarIcon
            travelDate={tripDetails.travelDate}
            isPast={isPast}
          />
        </div>
        <div className="flag__fix amr-10">
          <TripTypeIcon
            tripDetails={tripDetails}
            isPast={isPast}
          />
        </div>
        <div className="flag__flex">
          <h5 className={`fs-17 lh-solid apr-10 t-truncate ${headingColor}`}>
            {formatTripName(tripDetails)}
          </h5>
          <Truncate className="fs-14 lh-copy c-black-50" width="98%">
            {tripDetails.travellers || '--'}
          </Truncate>
        </div>
      </Link>
    </ListItem>
  )
}

export default tripsListItem
